// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file events/v1/error.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Any, Timestamp } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_any, file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file events/v1/error.proto.
 */
export const file_events_v1_error: GenFile =
    /*@__PURE__*/
    fileDesc(
        'ChVldmVudHMvdjEvZXJyb3IucHJvdG8SCWV2ZW50cy52MSJtCgVFcnJvchIlCgdwYXlsb2FkGAEgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueRIOCgZyZWFzb24YAiABKAkSLQoJdGltZXN0YW1wGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEJmCg1jb20uZXZlbnRzLnYxQgpFcnJvclByb3RvUAFaBC4vcGKiAgNFWFiqAglFdmVudHMuVjHKAglFdmVudHNcVjHiAhVFdmVudHNcVjFcR1BCTWV0YWRhdGHqAgpFdmVudHM6OlYxYgZwcm90bzM',
        [file_google_protobuf_any, file_google_protobuf_timestamp]
    );

/**
 * @generated from message events.v1.Error
 */
export type Error = Message<'events.v1.Error'> & {
    /**
     * @generated from field: google.protobuf.Any payload = 1;
     */
    payload?: Any | undefined;

    /**
     * @generated from field: string reason = 2;
     */
    reason: string;

    /**
     * @generated from field: google.protobuf.Timestamp timestamp = 3;
     */
    timestamp?: Timestamp | undefined;
};

/**
 * Describes the message events.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/ messageDesc(file_events_v1_error, 0);
